import { render, staticRenderFns } from "./register-invoice.vue?vue&type=template&id=43116f5d&scoped=true&"
import script from "./register-invoice.vue?vue&type=script&lang=ts&"
export * from "./register-invoice.vue?vue&type=script&lang=ts&"
import style0 from "./register-invoice.vue?vue&type=style&index=0&id=43116f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43116f5d",
  null
  
)

export default component.exports